import React from "react";
import styled from "styled-components";
import SearchBar from "../common/Search/SearchBar";

// Container principal
const Container = styled.div`
  display: flex;
  top: 55px; /* Alinhamento abaixo do Navbar */
  left: 203px; /* Alinhamento ao lado do Sidebar */
  justify-content: space-between;
  align-items: center;
  padding: 17px 30px;
  background-color: #f9f9f9;
  border-bottom: 1px solid #ddd;
  z-index: 5;
`;

const HighlightedText = styled.span`
  color: #FF9F1F;
  font-style: italic;
`;

// Texto estilizado
const WelcomeText = styled.div`
  font-size: 18px;
  color: black;
  font-weight: bold;
`;

const BemVindoComponent = () => {
  return (
    <Container>
      <WelcomeText>
        <HighlightedText>Bem-vindo</HighlightedText> ao módulo de atividades práticas / Estágios  
      </WelcomeText>
      <SearchBar />
    </Container>
  );
};

export default BemVindoComponent;
